// assets/product-dual-atc.js
(function(){
    function addToCart(variantId, qty, productForm){
      // NEW FEATURE: If member mode is active, check if we're trying to add a Non-Member variant
      // and if so, switch to the Member variant instead
      var isMemberMode = window.MemberMode && window.MemberMode.get();
      
      if (isMemberMode && productForm) {
        // Try to find if this is a Non-Member variant and get the Member variant instead
        var correctedVariantId = findCorrectVariantId(productForm, 'Member', variantId);
        if (correctedVariantId && correctedVariantId !== variantId) {
          console.log('Member mode active - switching from Non-Member variant', variantId, 'to Member variant', correctedVariantId);
          variantId = correctedVariantId;
        }
      }
      
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type':'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: qty || 1 })
      }).then(function(r){ 
        if (!r.ok) throw new Error('Failed to add to cart');
        return r.json(); 
      });
    }
  
    function updateCartUsingThemeMethod() {
      console.log('Updating cart using simplified method...');
      
      return new Promise(function(resolve, reject) {
        const cartDrawer = document.querySelector('cart-drawer');
        const cartDrawerItems = document.querySelector('cart-drawer-items');
        
        // Check if cart was empty before adding item
        const wasEmpty = cartDrawer && cartDrawer.classList.contains('is-empty');
        console.log('Cart was empty before adding:', wasEmpty);
        
        if (cartDrawerItems && typeof cartDrawerItems.updateCart === 'function') {
          console.log('Found cart drawer items updateCart method');
          try {
            // If cart was empty, we need to force remove empty state first
            if (wasEmpty) {
              console.log('Removing empty state classes before update');
              cartDrawer.classList.remove('is-empty');
              cartDrawerItems.classList.remove('is-empty');
            }
            
            cartDrawerItems.updateCart();
            console.log('Cart drawer items updateCart called successfully');
            
            // Double-check empty state is removed after update
            setTimeout(function() {
              if (cartDrawer.classList.contains('is-empty')) {
                console.log('Forcing removal of empty state after update');
                cartDrawer.classList.remove('is-empty');
                cartDrawerItems.classList.remove('is-empty');
              }
            }, 100);
            
            resolve();
          } catch (error) {
            console.error('updateCart method failed:', error);
            reject(error);
          }
        } else {
          console.log('No updateCart method found, using manual refresh');
          // Simple fallback: just reload the page
          window.location.reload();
        }
      });
    }
  
    function openCartDrawer(){
      const cartDrawer = document.querySelector('cart-drawer');
      
      if (cartDrawer) {
        console.log('Opening cart drawer...');
        
        // Try the theme's open method first
        if (typeof cartDrawer.open === 'function') {
          console.log('Using cart drawer open() method');
          cartDrawer.open();
        } else {
          console.log('Using fallback: adding active class');
          cartDrawer.classList.add('active');
        }
      }
      
      // Trigger cart update events
      document.dispatchEvent(new CustomEvent('cart:refresh'));
      document.dispatchEvent(new CustomEvent('cart:updated'));
      document.dispatchEvent(new CustomEvent('cartQuantityUpdated'));
    }
  
    // Set up listeners to keep the visible price matched to the selected variant.
    function setupVariantChangeListeners() {
      updateVariantPriceDisplay();

      document.querySelectorAll('variant-selects input, variant-selects select').forEach(function(input) {
        if (input.dataset.variantPriceListenerBound === 'true') return;
        input.dataset.variantPriceListenerBound = 'true';
        input.addEventListener('change', function() {
          setTimeout(function() {
            updateVariantPriceDisplay();
            updatePricingDisplay();
          }, 0);
        });
      });

      document.addEventListener('variant:change', function() {
        setTimeout(function() {
          updateVariantPriceDisplay();
          updatePricingDisplay();
        }, 0);
      });
    }
    
    // Helper function to find the correct variant based on membership type and selected options  
    function findCorrectVariantId(productForm, membershipType, currentVariantId) {
      if (!productForm) return currentVariantId;
      
      // Try to get product variants from JSON script tag or window object
      var productVariants = null;
      
      // Check for variants in JSON script tag with data-product-variants attribute
      var variantScript = document.querySelector('script[data-product-variants]');
      if (variantScript) {
        try {
          productVariants = JSON.parse(variantScript.textContent);
        } catch(e) {}
      }
      
      // Also try looking for any application/json script in the form
      if (!productVariants) {
        variantScript = productForm.querySelector('script[type="application/json"]');
        if (variantScript) {
          try {
            productVariants = JSON.parse(variantScript.textContent);
          } catch(e) {}
        }
      }
      
      // Fallback: check if pagefly exposed product data
      if (!productVariants && window.__pageflyProducts) {
        var productId = productForm.dataset.productId || productForm.querySelector('[data-product-id]')?.dataset.productId;
        if (productId && window.__pageflyProducts[productId]) {
          productVariants = window.__pageflyProducts[productId].variants;
        }
      }
      
      if (!productVariants || productVariants.length === 0) {
        return currentVariantId;
      }
      
      // Get the currently selected options (excluding Membership)
      var selectedOptions = [];
      var allInputs = productForm.querySelectorAll('input[type="radio"]:checked, select');
      
      allInputs.forEach(function(input) {
        var optionName = input.getAttribute('name');
        if (optionName && optionName !== 'id' && optionName !== 'quantity' && optionName !== 'Membership') {
          selectedOptions.push(input.value);
        }
      });
      
      // If no options found via checked inputs, parse current variant to extract size/options
      if (selectedOptions.length === 0 && currentVariantId) {
        var currentVariant = productVariants.find(function(v) {
          return v.id.toString() === currentVariantId.toString();
        });
        
        if (currentVariant) {
          [currentVariant.option1, currentVariant.option2, currentVariant.option3].forEach(function(opt) {
            if (opt && opt !== 'Member' && opt !== 'Non-Member') {
              selectedOptions.push(opt);
            }
          });
        }
      }
      
      // Find the variant that matches the membership type AND all selected options
      var matchingVariant = productVariants.find(function(variant) {
        var hasMembership = variant.option1 === membershipType || 
                            variant.option2 === membershipType || 
                            variant.option3 === membershipType;
        
        if (!hasMembership) return false;
        
        var hasAllSelectedOptions = selectedOptions.every(function(optValue) {
          return variant.option1 === optValue || 
                 variant.option2 === optValue || 
                 variant.option3 === optValue;
        });
        
        return hasMembership && hasAllSelectedOptions;
      });
      
      return matchingVariant ? matchingVariant.id.toString() : currentVariantId;
    }

    function getProductVariants(productForm) {
      var variantScript = null;

      if (productForm) {
        var variantSelects = document.querySelector('variant-selects[data-section="' + productForm.dataset.section + '"]');
        variantScript = variantSelects ? variantSelects.querySelector('script[type="application/json"]') : null;
        if (!variantScript) {
          variantScript = productForm.querySelector('script[type="application/json"]');
        }
      }

      if (!variantScript) {
        variantScript = document.querySelector('variant-selects script[type="application/json"]');
      }

      if (!variantScript) return [];

      try {
        return JSON.parse(variantScript.textContent) || [];
      } catch(e) {
        console.error('Could not parse product variants for price update:', e);
        return [];
      }
    }

    function getSelectedOptionValues(productForm) {
      var selectedOptions = [];
      var scope = productForm || document;
      var optionInputs = scope.querySelectorAll('input[type="radio"]:checked, select');

      if (!optionInputs.length) {
        optionInputs = document.querySelectorAll('variant-selects input[type="radio"]:checked, variant-selects select');
      }

      optionInputs.forEach(function(input) {
        var optionName = input.getAttribute('name') || '';
        optionName = optionName.replace(/^options\[(.*)\]$/, '$1');
        if (!optionName || optionName === 'id' || optionName === 'quantity' || optionName === 'Membership') return;
        selectedOptions.push(input.value);
      });

      return selectedOptions;
    }

    function hasMembership(variant, membershipType) {
      return variant.option1 === membershipType || variant.option2 === membershipType || variant.option3 === membershipType;
    }

    function findVariantForMembership(productVariants, membershipType, selectedOptions, fallbackVariant) {
      var matchingVariant = productVariants.find(function(variant) {
        if (!hasMembership(variant, membershipType)) return false;
        return selectedOptions.every(function(optValue) {
          return variant.option1 === optValue || variant.option2 === optValue || variant.option3 === optValue;
        });
      });

      if (matchingVariant) return matchingVariant;
      if (fallbackVariant && hasMembership(fallbackVariant, membershipType)) return fallbackVariant;

      return productVariants.find(function(variant) {
        return hasMembership(variant, membershipType);
      }) || null;
    }

    function formatVariantMoney(cents) {
      if (cents == null || isNaN(cents)) return '';

      if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
        return window.Shopify.formatMoney(cents);
      }

      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD'
      }).format(cents / 100);
    }

    function updateVariantPriceDisplay() {
      var productForm = document.querySelector('product-form form') || document.querySelector('form[action*="/cart/add"]');
      var productVariants = getProductVariants(productForm);
      if (!productVariants.length) return;

      var variantInput = productForm ? productForm.querySelector('input[name="id"]') : document.querySelector('input[name="id"]');
      var currentVariantId = variantInput ? variantInput.value : null;
      var currentVariant = productVariants.find(function(variant) {
        return currentVariantId && variant.id.toString() === currentVariantId.toString();
      }) || productVariants.find(function(variant) { return variant.available !== false; }) || productVariants[0];

      if (!currentVariant) return;

      var selectedOptions = getSelectedOptionValues(productForm);
      if (!selectedOptions.length) {
        [currentVariant.option1, currentVariant.option2, currentVariant.option3].forEach(function(opt) {
          if (opt && opt !== 'Member' && opt !== 'Non-Member') selectedOptions.push(opt);
        });
      }

      var nonMemberVariant = findVariantForMembership(productVariants, 'Non-Member', selectedOptions, currentVariant);
      var memberVariant = findVariantForMembership(productVariants, 'Member', selectedOptions, currentVariant);
      var compareAtPrice = (nonMemberVariant && nonMemberVariant.compare_at_price) || (memberVariant && memberVariant.compare_at_price) || currentVariant.compare_at_price;

      document.querySelectorAll('.product-page-price .price--member-enabled').forEach(function(priceBlock) {
        if (nonMemberVariant) {
          priceBlock.querySelectorAll('.price-item--non-member, .price-item--sale-non-member').forEach(function(el) {
            el.textContent = formatVariantMoney(nonMemberVariant.price);
          });
        }

        if (memberVariant) {
          priceBlock.querySelectorAll('.price-item--member, .price-item--sale-member').forEach(function(el) {
            el.textContent = formatVariantMoney(memberVariant.price);
          });
        }

        priceBlock.querySelectorAll('.price__compare-price .price-item--regular, .main-comapre-price').forEach(function(el) {
          if (compareAtPrice) {
            el.textContent = formatVariantMoney(compareAtPrice);
            el.closest('.price__compare-price')?.classList.remove('hidden');
          }
        });

        // Base the "Save X%" badge on the member (VIP) price that is actually displayed.
        var badgeVariant = memberVariant || nonMemberVariant;
        if (compareAtPrice && badgeVariant && compareAtPrice > badgeVariant.price) {
          var percentageSaved = Math.floor(((compareAtPrice - badgeVariant.price) * 100) / compareAtPrice);
          var moneySaved = formatVariantMoney(compareAtPrice - badgeVariant.price).replace(/\.00$/, '');
          priceBlock.querySelectorAll('.badge__percentage-saved').forEach(function(el) { el.textContent = percentageSaved; });
          priceBlock.querySelectorAll('.badge__money-saved').forEach(function(el) { el.textContent = moneySaved; });
        }
      });

      // Keep the VIP purchase section (heading + dual button prices) matched to the selected variant.
      if (nonMemberVariant) {
        document.querySelectorAll('.member-offer--price').forEach(function(el) {
          el.textContent = formatVariantMoney(nonMemberVariant.price);
        });
        document.querySelectorAll('.add-to-cart-nonmember .dual-atc-price-amount').forEach(function(el) {
          el.textContent = formatVariantMoney(nonMemberVariant.price);
        });
      }
      if (memberVariant) {
        document.querySelectorAll('.add-to-cart-member .dual-atc-price-amount').forEach(function(el) {
          el.textContent = formatVariantMoney(memberVariant.price);
        });
      }
    }
  
    function updatePricingDisplay() {
      // Check localStorage first (especially important on cart page for immediate application)
      let isMemberMode = false;
      let isFreeTeeMode = false;
      
      try {
        const memberModeValue = localStorage.getItem('member_mode') === 'true';
        const freeTeeModeValue = localStorage.getItem('freetee_mode') === 'true';
        
        isMemberMode = memberModeValue || 
                       document.body.classList.contains('member-mode') || 
                       (window.MemberMode && window.MemberMode.get());
        isFreeTeeMode = freeTeeModeValue || 
                        document.body.classList.contains('freetee-mode') || 
                        (window.MemberMode && window.MemberMode.getFreeTeeMode());
        
        // FreeTee mode overrides member mode - customers must pay non-member price
        if (isFreeTeeMode) {
          isMemberMode = false;
        }
      } catch(e) {
        isMemberMode = document.body.classList.contains('member-mode') || 
                       (window.MemberMode && window.MemberMode.get());
        isFreeTeeMode = document.body.classList.contains('freetee-mode') || 
                        (window.MemberMode && window.MemberMode.getFreeTeeMode());
        if (isFreeTeeMode) {
          isMemberMode = false;
        }
      }
      
      // Update all non-member buttons based on member mode
      document.querySelectorAll('.add-to-cart-nonmember').forEach(function(btn) {
        if (isMemberMode) {
          btn.disabled = true;
        } else {
          btn.disabled = false;
        }
      });
      
      // Update pricing blocks
      document.querySelectorAll('.pricing-block').forEach(function(block) {
        if (isMemberMode) {
          block.classList.add('member-mode-active');
        } else {
          block.classList.remove('member-mode-active');
        }
      });
      
      // Hide/show member offer based on freetee mode
      document.querySelectorAll('.member-offer').forEach(function(offer) {
        if (isFreeTeeMode) {
          offer.style.display = 'none';
        } else {
          // Show member offer when NOT in freetee mode
          offer.style.setProperty('display', 'block', 'important');
          offer.style.setProperty('visibility', 'visible', 'important');
          offer.style.setProperty('opacity', '1', 'important');
          offer.style.setProperty('max-height', 'none', 'important');
        }
      });
      
      // Update single member button visibility
      document.querySelectorAll('.member-mode-single-button').forEach(function(btn) {
        if (isMemberMode && !isFreeTeeMode) {
          btn.style.display = 'block';
        } else {
          btn.style.display = 'none';
        }
      });
      
      // Apply direct inline styles for all pages (same approach that works on product pages)
      // Remove any existing inline styles first
      document.querySelectorAll('.price-item--member, .price-item--sale-member, .price-item--non-member, .price-item--sale-non-member').forEach(function(el) {
        el.style.removeProperty('display');
        el.style.removeProperty('visibility');
        el.style.removeProperty('opacity');
      });
      
      // Then apply appropriate styles based on current mode
      if (!isMemberMode && !isFreeTeeMode) {
        // Force non-member prices when not in any special mode
        document.querySelectorAll('.price-item--member, .price-item--sale-member').forEach(function(el) {
          el.style.setProperty('display', 'none', 'important');
          el.style.setProperty('visibility', 'hidden', 'important');
          el.style.setProperty('opacity', '0', 'important');
        });
        
        document.querySelectorAll('.price-item--non-member, .price-item--sale-non-member').forEach(function(el) {
          el.style.setProperty('display', 'inline', 'important');
          el.style.setProperty('visibility', 'visible', 'important');
          el.style.setProperty('opacity', '1', 'important');
        });
      } else {
        // Force member prices when in member mode
        document.querySelectorAll('.price-item--non-member, .price-item--sale-non-member').forEach(function(el) {
          el.style.setProperty('display', 'none', 'important');
          el.style.setProperty('visibility', 'hidden', 'important');
          el.style.setProperty('opacity', '0', 'important');
        });
        
        document.querySelectorAll('.price-item--member, .price-item--sale-member').forEach(function(el) {
          el.style.setProperty('display', 'inline', 'important');
          el.style.setProperty('visibility', 'visible', 'important');
          el.style.setProperty('opacity', '1', 'important');
        });
      }

      // The MAIN product price element always shows the MEMBER price, regardless of mode.
      // Runs last so it overrides the non-member forcing above.
      document.querySelectorAll('.main-price.price-item--non-member, .main-price.price-item--sale-non-member').forEach(function(el) {
        el.style.setProperty('display', 'none', 'important');
        el.style.setProperty('visibility', 'hidden', 'important');
        el.style.setProperty('opacity', '0', 'important');
      });
      document.querySelectorAll('.main-price.price-item--member, .main-price.price-item--sale-member').forEach(function(el) {
        el.style.setProperty('display', 'inline', 'important');
        el.style.setProperty('visibility', 'visible', 'important');
        el.style.setProperty('opacity', '1', 'important');
      });

      // Collection / listing cards always show the MEMBER price, regardless of mode.
      document.querySelectorAll('.price--card-member .price-item--non-member, .price--card-member .price-item--sale-non-member').forEach(function(el) {
        el.style.setProperty('display', 'none', 'important');
        el.style.setProperty('visibility', 'hidden', 'important');
        el.style.setProperty('opacity', '0', 'important');
      });
      document.querySelectorAll('.price--card-member .price-item--member, .price--card-member .price-item--sale-member').forEach(function(el) {
        el.style.setProperty('display', 'inline', 'important');
        el.style.setProperty('visibility', 'visible', 'important');
        el.style.setProperty('opacity', '1', 'important');
      });
    }

    // Make updatePricingDisplay globally available for cart change events
    window.updatePricingDisplay = updatePricingDisplay;
    
    // Force pricing update by directly checking cart
    function forceUpdatePricingFromCart() {
      if (window.MemberMode && window.MemberMode.refreshFromServer) {
        // Add delay to ensure server has processed cart changes before we check
        setTimeout(function() {
          window.MemberMode.refreshFromServer().then(function() {
            updatePricingDisplay();
          }).catch(function(error) {
            console.error('Failed to refresh member mode:', error);
            updatePricingDisplay();
          });
        }, 300);
      } else {
        updatePricingDisplay();
      }
    }
    
    window.forceUpdatePricingFromCart = forceUpdatePricingFromCart;
  
    function bindDualButtons(){
      updatePricingDisplay();
      setupVariantChangeListeners();
      
      document.querySelectorAll('.add-to-cart-nonmember').forEach(function(btn){
        btn.addEventListener('click', function(e){
          e.preventDefault();
          
          var productForm = btn.closest('product-form') || btn.closest('form');
          var selectedVariantInput = productForm ? productForm.querySelector('input[name="id"]') : null;
          var currentVariantId = selectedVariantInput ? selectedVariantInput.value : null;
          
          // Find the Non-Member variant that matches the currently selected size/options
          var id = findCorrectVariantId(productForm, 'Non-Member', currentVariantId);
          
          if (!id) {
            id = btn.getAttribute('data-variant-id');
          }
          
          if (!id) {
            console.error('No variant ID found');
            return;
          }
          
          btn.classList.add('loading');
          btn.disabled = true;
          
          // Get quantity from the quantity input field
          var quantityInput = productForm ? productForm.querySelector('input[name="quantity"], #Quantity-' + productForm.dataset.section) : null;
          var quantity = quantityInput ? parseInt(quantityInput.value) || 1 : 1;
          
          addToCart(id, quantity, productForm).then(function(result){
            updateCartUsingThemeMethod().then(function(){
              openCartDrawer();
              setTimeout(forceUpdatePricingFromCart, 200);
              
              btn.textContent = 'Added!';
              setTimeout(function(){
                btn.textContent = 'Add to Cart';
              }, 2000);
            }).catch(function(error){
              console.error('Cart update failed:', error);
            });
          }).catch(function(error){
            console.error('Failed to add to cart:', error);
            alert('Failed to add to cart. Please try again.');
          }).finally(function(){
            btn.classList.remove('loading');
            btn.disabled = false;
          });
        });
      });
  
      document.querySelectorAll('.add-to-cart-member').forEach(function(btn){
        btn.addEventListener('click', function(e){
          e.preventDefault();
          console.log('Member button clicked');
          
          // Get the currently selected variant from the product form
          var productForm = btn.closest('product-form') || btn.closest('form');
          var selectedVariantInput = productForm ? productForm.querySelector('input[name="id"]') : null;
          var currentVariantId = selectedVariantInput ? selectedVariantInput.value : null;
          
          // For products with Member/Non-Member variants, we need to find the Member variant
          // that matches the currently selected size/options
          var id = findCorrectVariantId(productForm, 'Member', currentVariantId);
          
          // Fallback to button's data attribute if variant finding fails
          if (!id) {
            id = btn.getAttribute('data-variant-id');
          }
          
          console.log('Variant ID:', id);
          if (!id) {
            console.error('No variant ID found');
            return;
          }
          
          btn.classList.add('loading');
          btn.disabled = true;
          
          // Get quantity from the quantity input field
          var quantityInput = productForm ? productForm.querySelector('input[name="quantity"], #Quantity-' + productForm.dataset.section) : null;
          var quantity = quantityInput ? parseInt(quantityInput.value) || 1 : 1;
          
          addToCart(id, quantity, productForm).then(function(result){
            updateCartUsingThemeMethod().then(function(){
              openCartDrawer();
              setTimeout(forceUpdatePricingFromCart, 200);
              
              btn.textContent = 'Added to VIP!';
              setTimeout(function(){
                btn.textContent = 'Join VIP & Save';
              }, 2000);
            }).catch(function(error){
              console.error('Cart update failed:', error);
            });
          }).catch(function(error){
            console.error('Failed to add to cart:', error);
            alert('Failed to add to cart. Please try again.');
          }).finally(function(){
            btn.classList.remove('loading');
            btn.disabled = false;
          });
        });
      });
  
      // Bind single member button for member mode
      document.querySelectorAll('.add-to-cart-member-single').forEach(function(btn){
        btn.addEventListener('click', function(e){
          e.preventDefault();
          
          var productForm = btn.closest('product-form') || btn.closest('form');
          var selectedVariantInput = productForm ? productForm.querySelector('input[name="id"]') : null;
          var currentVariantId = selectedVariantInput ? selectedVariantInput.value : null;
          
          var id = findCorrectVariantId(productForm, 'Member', currentVariantId);
          
          if (!id) {
            id = btn.getAttribute('data-variant-id');
          }
          
          if (!id) {
            console.error('No variant ID found');
            return;
          }
          
          btn.classList.add('loading');
          btn.disabled = true;
          
          // Get quantity from the quantity input field
          var quantityInput = productForm ? productForm.querySelector('input[name="quantity"], #Quantity-' + productForm.dataset.section) : null;
          var quantity = quantityInput ? parseInt(quantityInput.value) || 1 : 1;
          
          addToCart(id, quantity, productForm).then(function(result){
            updateCartUsingThemeMethod().then(function(){
              openCartDrawer();
              setTimeout(forceUpdatePricingFromCart, 200);
              
              var originalText = btn.textContent;
              btn.textContent = 'Added!';
              setTimeout(function(){
                btn.textContent = originalText;
              }, 2000);
            }).catch(function(error){
              console.error('Cart update failed:', error);
            });
          }).catch(function(error){
            console.error('Failed to add to cart:', error);
            alert('Failed to add to cart. Please try again.');
          }).finally(function(){
            btn.classList.remove('loading');
            btn.disabled = false;
          });
        });
      });
      
      // Dual buttons bound successfully
    }
  
    function bindQuickAddButtons(){
      document.addEventListener('click', function(e){
        var btn = e.target.closest('.card-quick-add');
        if (!btn) return;
        
        // Prevent default form submission
        e.preventDefault();
        e.stopPropagation();
  
        var isMember = document.body.classList.contains('member-mode') || 
                       (window.MemberMode && window.MemberMode.get());
        var id = isMember ? 
                 btn.getAttribute('data-variant-member-id') : 
                 btn.getAttribute('data-variant-nonmember-id');
  
        // Fallback: if no member/non-member variant data attributes, get variant from form
        if (!id) {
          var productForm = btn.closest('product-form') || btn.closest('form');
          if (productForm) {
            var variantInput = productForm.querySelector('input[name="id"]');
            if (variantInput) {
              id = variantInput.value;
            }
          }
        }
  
        if (!id) {
          console.error('Quick add: No variant ID found for button', btn);
          return;
        }
  
        console.log('Quick add: Adding variant', id, 'to cart');
        btn.classList.add('loading');
        
        // For quick-add buttons, always use quantity 1 since they don't have a quantity selector
        // Note: Quick-add buttons already handle member/non-member selection above
        addToCart(id, 1, null).then(function(result){
          updateCartUsingThemeMethod().then(function(){
            openCartDrawer();
            setTimeout(forceUpdatePricingFromCart, 200);
          }).catch(function(error){
            console.error('Cart update failed:', error);
          });
        }).catch(function(error){
          console.error('Failed to add via quick-add:', error);
          alert('Failed to add to cart. Please try again.');
        }).finally(function(){
          btn.classList.remove('loading');
        });
      });
    }
  
    function setupCartChangeDetection() {
      let updateInProgress = false;
      let debounceTimer = null;
      
      function debouncedUpdate() {
        if (updateInProgress) return;
        
        if (debounceTimer) {
          clearTimeout(debounceTimer);
        }
        
        debounceTimer = setTimeout(function() {
          updateInProgress = true;
          forceUpdatePricingFromCart();
          
          setTimeout(function() {
            updateInProgress = false;
          }, 1000);
        }, 500);
      }
      
      // Watch for changes to the cart drawer content
      const cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer) {
        const observer = new MutationObserver(function(mutations) {
          const hasContentChange = mutations.some(function(mutation) {
            return mutation.type === 'childList' && mutation.addedNodes.length > 0;
          });
          
          if (hasContentChange) {
            debouncedUpdate();
          }
        });
      
        observer.observe(cartDrawer, {
          childList: true,
          subtree: true
        });
      }
      
      // Listen for cart events
      document.addEventListener('cart:refresh', debouncedUpdate);
      document.addEventListener('cart:updated', debouncedUpdate);
      document.addEventListener('cartQuantityUpdated', debouncedUpdate);
      
      // Listen for member mode changes (from collection navigation)
      document.addEventListener('memberModeChanged', function(e) {
        console.log('Member mode changed event received:', e.detail);
        updatePricingDisplay();
      });
      
      // Update pricing when cart drawer closes
      document.addEventListener('click', function(e) {
        if (e.target.closest('.drawer__close') || e.target.closest('[data-close-drawer]')) {
          setTimeout(updatePricingDisplay, 500);
        }
      });
      
      document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape') {
          setTimeout(updatePricingDisplay, 500);
        }
      });
    }
  
    var initialized = false;
    
    function init(){
      if (initialized) return;
      initialized = true;
      
      bindDualButtons();
      bindQuickAddButtons();
      setupCartChangeDetection();
    }
  
    if (document.readyState !== 'loading') {
      init();
    } else {
      document.addEventListener('DOMContentLoaded', init);
    }
  
    // Re-bind when sections are loaded in theme editor
    if (window.Shopify && window.Shopify.designMode) {
      document.addEventListener('shopify:section:load', function(){
        initialized = false;
        init();
      });
    }
    
    // Delayed initialization for late-loading elements
    setTimeout(init, 1000);
  })();